// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopReviewsStarRating_container__XG5TN"};